/* Footer contact pop-up: posts Shopify's contact form without leaving the page.
   Messages are delivered by Shopify to the store's sender email. */
(() => {
  const modal = document.querySelector('[data-contact-modal]');
  if (!modal || modal.dataset.init) return;
  modal.dataset.init = '1';
  const form = modal.querySelector('form[data-contact-form]');
  const fields = modal.querySelector('[data-contact-fields]');
  const done = modal.querySelector('[data-contact-done]');
  const errorEl = modal.querySelector('[data-contact-error]');
  const submit = modal.querySelector('[data-contact-submit]');
  const openModal = () => window.TINOR && window.TINOR.open(modal);

  const showDone = () => {
    fields.hidden = true;
    done.hidden = false;
    errorEl.hidden = true;
  };
  const showError = msg => {
    errorEl.textContent = msg || errorEl.dataset.fallback || 'Something went wrong. Please try again.';
    errorEl.hidden = false;
  };

  // After a normal (non-JS) post Shopify reloads the page: reopen the pop-up with the result.
  if (modal.querySelector('[data-contact-posted]') || !errorEl.hidden) {
    window.addEventListener('load', openModal);
  }

  // Reset to the empty form each time it's opened after a successful send.
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-open="ContactModal"]')) return;
    if (!done.hidden) { form.reset(); done.hidden = true; fields.hidden = false; }
  }, true);

  // Every link to the contact page (menus, buttons, rich text) opens this pop-up instead.
  // Ctrl/cmd/middle clicks still open the page itself.
  const isContactLink = a => {
    if (!a || !a.href || a.target === '_blank') return false;
    try {
      const url = new URL(a.href, location.href);
      return url.origin === location.origin && /(^|\/)pages\/contact\/?$/.test(url.pathname);
    } catch (_) { return false; }
  };
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!isContactLink(a)) return;
    e.preventDefault();
    const mega = document.querySelector('[data-mega].is-open');
    if (mega) {
      mega.classList.remove('is-open');
      document.querySelectorAll('[data-mega-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
    if (!done.hidden) { form.reset(); done.hidden = true; fields.hidden = false; }
    openModal();
  });

  form.addEventListener('submit', e => {
    e.preventDefault();
    if (!form.reportValidity()) return;
    submit.classList.add('is-loading');
    errorEl.hidden = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(res => {
        // Shopify can ask for a bot check: fall back to a normal post.
        if (/\/challenge/.test(res.url)) { form.submit(); return null; }
        return res.text().then(html => ({ res, html }));
      })
      .then(out => {
        if (!out) return;
        submit.classList.remove('is-loading');
        const doc = new DOMParser().parseFromString(out.html, 'text/html');
        const scope = doc.getElementById(form.id) || doc;
        const posted = /contact_posted=true/.test(out.res.url) || !!scope.querySelector('[data-contact-posted]');
        if (posted) { showDone(); return; }
        const err = scope.querySelector('[data-contact-error]');
        showError(err && err.textContent.trim());
      })
      .catch(() => { submit.classList.remove('is-loading'); form.submit(); });
  });
})();
